import { ManagerConfig } from "config/manager-config";
import { handle, Store } from "fw-state";

export class SetConfigAction {
    constructor(public config: ManagerConfig = null) {}
}

export class ConfigStore extends Store<ManagerConfig> {
    constructor() {
        super();
    }

    defaultState(): ManagerConfig {
        return { apiUrl: "", flags: {} };
    }

    @handle(SetConfigAction)
    private handleSetConfigAction(action: SetConfigAction) {
        this.setState(() => action.config);
    }
}
